import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/recollects/:id',
  title: 'title.show',
  endpoint: '/app/purchase/request_recollect',
  breadcrumbs: [],
}
